import CombineIcon from "@shared/assets/eds-custom-icons/Day_Night.svg?react";
import {
  TransitionType,
  transitionTypeTranslation,
} from "@opstel/query/models/planTrainUnitDetails/planTrainUnitDetails";
import { AriaAttributes, FunctionComponent } from "react";

interface TransitionIconProps {
  readonly transition: TransitionType;
}

export function TransitionIcon({ transition }: TransitionIconProps) {
  const Icon = iconMap[transition];
  return (
    <div className="text-emphasis">
      <Icon aria-label={transitionTypeTranslation[transition]} />
    </div>
  );
}

const iconMap: Record<TransitionType, FunctionComponent<AriaAttributes>> = {
  DAY: (props: AriaAttributes) => <tractie-icon name="sun" aria-label={props["aria-label"]} />,
  NIGHT: (props: AriaAttributes) => <tractie-icon name="moon" aria-label={props["aria-label"]} />,
  NIGHT_OUTSIDE_SCENARIO: (props: AriaAttributes) => (
    <CombineIcon aria-label={props["aria-label"]} className="block fill-none stroke-1" />
  ),
};
